<template>
  <div
    class="m-card"
    :class="{ 'm-card--selected': selected }"
    :title="title"
    @click.self="!selected ? $emit('action') : null">
    <!--Should probably be an icon only v-button-->
    <a
      v-if="selected === true"
      class="m-card__remove"
      @click="$emit('removeAction')">
        <XMarkIcon />
    </a>
    <!-- TODO image loader is a directive in the app. This should probably be re-created in the component library and improved -->
    <img
      class="m-card__image"
      v-image-loader="{
        src: `${imageSrc}`,
        onerror: require('@/assets/error.png'),
        ratio: imageRatio,
      }"
      v-if="!loading"
      data-hj-suppress />
    <div
      class="m-card__details"
      :class="{ 'm-card__details--selected': selected }">
        <div class="m-card__details__title" data-hj-suppress>
          {{ title }}
        </div>
        <div class="m-card__details__date">
          <CalendarIcon
            height="10"
            width="10"
          />
          {{ formatDate(date) }}
        </div>
    </div>
  </div>
</template>

<script>
import Moment from 'moment';
import { CalendarIcon, XMarkIcon } from '@/components/icons/fontIcons';

export default {
  // Should probably be renamed document card
  name: 'VCard',
  introduction: 'Card for previewing documents.',
  components: {
    CalendarIcon,
    XMarkIcon,
  },
  props: {
    title: {
      type: String,
      note: 'The title of the document.',
    },
    date: {
      type: Number,
      note: 'The unix timestamp the document was created.',
    },
    imageSrc: {
      type: String,
      note: 'The url of the document preview image.',
    },
    imageRatio: {
      type: Number,
      default: 1,
      note: 'The initial ratio of the height / width before the image is loaded.',
    },
    selected: {
      type: Boolean,
      default: false,
      note: 'Sets if the document is initially selected.',
    },
    loading: {
      type: Boolean,
      default: false,
      note: 'Needs investigation what this is doing.',
    },
  },
  // Should probably v-model the selected state
  computed: {
    ratioPadding() {
      if (!this.loading || !this.imageRatio) {
        return 0;
      }
      const imagePercent = this.imageRatio * 100;
      return `${imagePercent}%`;
    },
  },
  methods: {
    formatDate(UnixDate, format = 'Do MMMM YYYY HH:mm') {
      return Moment.unix(UnixDate).format(format);
    },
  },
};
</script>

<style scoped>
.m-card {
  position: relative;
  border: 1px solid var(--color-border);
  box-shadow: 0px 0px 5px -2px var(--color-border);
  border-radius: 9px;
  height: 100%;
  cursor: pointer;
  overflow: hidden;
  transition: 0.2s all ease;
}

.m-card:hover {
  box-shadow: 0px 0px 5px 0px var(--color-border);
}

.m-card--selected, .m-card--selected:hover {
  cursor: auto;
  border: 3px solid var(--signable-primary-1);
  margin: -2px;
}

.m-card__remove {
  position: absolute;
  cursor: pointer;
  background: var(--color-error);
  border: 1px solid var(--color-error-dark);
  color: #fff;
  right: var(--spacing-xs);
  top: var(--spacing-xs);
  line-height: 0;
  height: 22px;
  width: 22px;
  border-radius: 30px;
}

.m-card__remove svg {
  height: 12px;
  width: 12px;
  pointer-events: none;
  position: absolute;
  transform: translate3d(-50%, -50%, 0);
  top: 50%;
  left: 50%;
}

.m-card__image {
  width: 100%;
  height: auto;
  display: block;
  text-align: center;
  border-radius: 6px;
  pointer-events: none;
}

.m-card__details {
  text-align: left;
  background: rgba(0, 0, 0, 0.8);
  padding: calc(var(--spacing-small) - 2px);
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  pointer-events: none;
  color: #fff;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
}

.m-card__details__title {
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: var(--spacing-xs);
  font-size: calc(var(--font-size-medium) - 2px);
  line-height: var(--font-size-medium);
}

.m-card__details__date {
  font-size: 12px;
}

.m-card__details__date svg {
  margin-right: var(--spacing-xs);
}

.m-card__details--selected {
  background: var(--signable-primary-1);
  border-radius: 0;
}
</style>
